import React from 'react';
import { Menu, Dropdown } from '@arco-design/web-react';
import { useNavigate, useLocation } from 'react-router-dom';
export default function HomeHeader() {
  const navigate = useNavigate();
  const location = useLocation();

  // 路由和菜单key的映射
  const menuKeyMap = {
    '/home': '1',
    '/analysis': '2',
    '/private-customer': '3',
    '/member-manage': '4'
  };
  // 反向映射
  const keyRouteMap = {
    '1': '/home',
    '2': '/analysis',
    '3': '/private-customer',
    '4': '/member-manage'
  };
  // 当前路由对应的菜单key
  let selectedKey = '1';
  if (location.pathname.startsWith('/home')) {
    selectedKey = '1';
  } else if (location.pathname.startsWith('/analysis')) {
    selectedKey = '2';
  } else if (location.pathname.startsWith('/private-customer')) {
    selectedKey = '3';
  } else if (location.pathname.startsWith('/member-manage')) {
    selectedKey = '4';
  }
  // 菜单点击事件
  const handleMenuClick = (key) => {
    navigate(keyRouteMap[key]);
  };
  const handleLogout = () => {
    // 1. 清除本地存储的登录信息
    localStorage.removeItem('token'); // 假如你的 token 存在 localStorage
    // 2. 跳转到登录页
    navigate('/login');
  };
  return (
    <div style={{ background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', padding: '0 32px', display: 'flex', alignItems: 'center', height: 56 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginRight: 32 }}>
        <img src="/favicon.svg" alt="favicon" style={{ height: 32, marginRight: 8 }} />
        <span style={{ fontWeight: 700, fontSize: 18, color: '#3491fa' }}>智网识客</span>
      </div>
      <Menu
        mode="horizontal"
        selectedKeys={[selectedKey]}
        onClickMenuItem={handleMenuClick}
        style={{ flex: 1, background: 'transparent' }}
      >
        <Menu.Item key="1">收集内容评论</Menu.Item>
        <Menu.Item key="2">分析客户意向</Menu.Item>
        <Menu.Item key="3">私信意向客户</Menu.Item>
      </Menu>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
  <span 
  style={{ color: '#3491fa', fontWeight: 600, cursor: 'pointer' }}
  onClick={() => window.open('https://xcn9f50y4vw5.feishu.cn/wiki/Y26hwDUgAioiDzkx7CbcZFC5n1b', '_blank')}
  >使用文档</span>
  <span style={{ color: 'orange' }}>会员时间</span>
  <span style={{ color: '#999' }}>至 2025-12-31</span>
    <span>
      <Dropdown droplist={<Menu>
        <Menu.Item onClick={handleLogout}>退出登录</Menu.Item></Menu>}>
        <span style={{ cursor: 'pointer' }}>智网识客 ▼</span>
      </Dropdown>
    </span>
</div>
    </div>
  );
}